module.exports = __webpack_public_path__ + "static/media/reachedTournamentTop10_7_10.698f3abf.png";